var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartesBancaires(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -9 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "url(#a)",
    stroke: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.825 19.407h7.853c-.07-1.697-.465-3.447-1.665-4.571C26.584 13.496 24.081 13 21.845 13c-2.328 0-4.902.545-6.338 1.982C14.267 16.218 14 18.21 14 20c0 1.874.524 4.054 1.868 5.31 1.429 1.335 3.744 1.69 5.977 1.69 2.17 0 4.519-.4 5.94-1.669 1.416-1.267 1.906-3.4 1.906-5.331v-.01h-7.866v-.582Zm8.38.584v6.696H41.13v-.01C42.728 26.592 44 25.15 44 23.38c0-1.77-1.272-3.304-2.87-3.392v.003H30.205Zm10.8-6.71c1.558 0 2.795 1.351 2.795 3.057 0 1.615-1.136 2.934-2.58 3.07H30.205V13.27h10.456c.064-.008.139-.003.212.003.046.003.091.006.132.006Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.732,
    y1: -5.065,
    x2: 1.637,
    y2: 38.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#40CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB792"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartesBancaires);
export default __webpack_public_path__ + "static/media/cartes-bancaires.e8245b09.svg";
export { ForwardRef as ReactComponent };